import { render, staticRenderFns } from "./frozen.vue?vue&type=template&id=45b7d1a6"
import script from "./frozen.vue?vue&type=script&lang=js"
export * from "./frozen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports